module.exports = __webpack_public_path__ + "img/carton.5831aff6.svg";